import style from './../../adminSect.module.scss';

const EditNoPhUserFields = (editingUser,handleCheckBox) => {
  const { passInput } = style;

  const pattern = '^[A-Za-z0-9-/_/-/ñ/Ñ]+$';

  const passConfirm = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('userPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error('¡Las contraseñas que ingresó no coinciden!'),
      );
    },
  });

  const fields = [
    {
      item: {
        label: 'Nombre completo',
        name: 'fullName',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre completo',
          },
        ],
        initialValue: (editingUser.fullName || '')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono',
        name: 'phoneNumber',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un número de teléfono',
          },
        ],
        initialValue: (editingUser.phoneNumber || '')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Email',
        name: 'email',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un email',
          },
        ],
        initialValue: (editingUser.email || '')
      },
      input: {  },
      inputTag: 'Input',
    },
    {
      item: {
        label: '¿Desea cambiar la contraseña?',
      },
      input: {
        onChange: handleCheckBox,
        id: 'adCheckbox',
      },
      inputTag: 'Checkbox',
    },
    {
      item: {
        label: 'Contraseña',
        name: 'userPassword',
        help: 'la contraseña tiene que tener entre 6 y 12 caracteres, simbolos permitidos: - _ ',
        rules: [
          {
            required: true,
            message: 'Por favor escriba su contraseña',
          },
          {
            min: 6,
            message: 'Largo de contraseña mínimo 6 caracteres',
          },
          {
            pattern: pattern,
            message: 'los unicos simbolos permitidos son - y _',
          },
          {
            max: 12,
            message: 'Máximo de caracteres permitidos es 12',
          },
        ],
      },
      input: {
        className: passInput,
        maxlength: 12,
        type: 'password',
      },
      inputTag: 'Input.Password',
    },
    {
      item: {
        label: 'Repita la contraseña',
        name: 'passRepeat',
        style: { marginTop: '1rem' },
        rules: [
          {
            required: true,
            message: 'Por favor confirme la contraseña',
          },
          {
            min: 6,
            message: 'Largo de contraseña mínimo 6 caracteres',
          },
          {
            max: 12,
            message: 'Máximo de caracteres permitidos es 12',
          },
          passConfirm,
        ],
      },
      input: {
        className: passInput,
        maxlength: 12,
        type: 'password',
        style: { marginBottom: '1rem' },
      },
      inputTag: 'Input.Password',
    },
  ];
  return fields;
};

export default EditNoPhUserFields;
